import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rules-tab"
}
const _hoisted_2 = { class: "rules-tab__choice-line" }
const _hoisted_3 = { class: "rules-tab__choice-line-label" }
const _hoisted_4 = { class: "rules-tab__choice-line" }
const _hoisted_5 = { class: "rules-tab__choice-line-label" }
const _hoisted_6 = { style: {"display":"flex","flex-direction":"column","gap":"8px"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "rules-tab__rule-group" }
const _hoisted_9 = {
  key: 0,
  class: "rules-tab__rule-body"
}
const _hoisted_10 = { class: "rules-tab__rule-body-bulk" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "rules-tab__selector-label" }
const _hoisted_14 = {
  key: 0,
  class: "rules-tab__field rules-tab__field--col"
}
const _hoisted_15 = { class: "rules-tab__field-name" }
const _hoisted_16 = { class: "rules-tab__field-value-col-time" }
const _hoisted_17 = { class: "rules-tab__field-value-col-name" }
const _hoisted_18 = { class: "rules-tab__field-value-col-action" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "rules-tab__actions" }

import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import AppSelect, {
  SelectOption,
} from "@/components/ui-kit/select/AppSelect.vue";
import UserGroupDropdownContent from "./UserGroupDropdownContent.vue";
import RulesSelectorDropdown from "./RulesSelectorDropdown.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { AccessApi } from "@/ api/AccessApi";
import {
  CommonEntity,
  CommonRule,
  EntityRulesContainer,
  RuleElement,
  WorkersAndAccessGroupsInSettingsGiver,
  RulesHistoryGiver,
} from "@/models/interfaces/access/entity-rules";
import moment from "moment";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { i18n } from "@/i18n";
import { formatChangelogText } from "@/utils/textHelpers";

interface SectionDef {
  key: string;
  title: string;
  rules: CommonRule[];
  visible: boolean;
  readonly: boolean;
  toggle: () => void;
}

const INITIAL_HISTORY_PAGE_SIZE = 4;
const HISTORY_PAGE_SIZE = 30;
const HISTORY_SCROLL_THRESHOLD = 100;


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPermitionsTab',
  props: {
    container: {},
    entityId: {},
    canEdit: { type: Boolean },
    type: {}
  },
  emits: ["refresh", "save", "cancel", "openDropdown", "closeDropdown"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localContainer = ref<EntityRulesContainer | null>(null);
const addGroupSection = ref<string | null>(null);
const availableGroups = ref<CommonEntity[]>([]);
const availableRulesTemplate = ref<RuleElement[]>([]);
const isLoadingGroups = ref(false);
const historyGroups = ref<RulesHistoryGiver>();
const isLoadingHistory = ref(false);
const isHistoryScrollLoadingEnabled = ref(false);
const historyScrollRef = ref<HTMLElement | null>(null);
const hasMoreHistory = computed(
  () =>
    !!historyGroups.value &&
    historyGroups.value.Records.length < historyGroups.value.TotalCount,
);

const loadHistory = async (reset = false) => {
  if (isLoadingHistory.value || (!reset && !hasMoreHistory.value)) return;

  isLoadingHistory.value = true;
  try {
    const skip = reset ? 0 : historyGroups.value?.Records.length ?? 0;
    const take = reset ? INITIAL_HISTORY_PAGE_SIZE : HISTORY_PAGE_SIZE;
    const nextPage =
      props.type === "client"
        ? await AccessApi.getHistoryInClient(
            props.entityId,
            skip,
            take,
          )
        : await AccessApi.getHistoryInProject(
            props.entityId,
            skip,
            take,
          );

    historyGroups.value = {
      TotalCount: nextPage.TotalCount,
      Records: reset
        ? nextPage.Records.slice(0, INITIAL_HISTORY_PAGE_SIZE)
        : [
            ...(historyGroups.value?.Records ?? []),
            ...nextPage.Records.slice(0, HISTORY_PAGE_SIZE),
          ],
    };
  } catch (e) {
    console.error(e);
  } finally {
    isLoadingHistory.value = false;
    await nextTick();
    if (isHistoryScrollLoadingEnabled.value) await fillHistoryViewport();
  }
};

const loadMoreHistory = () => loadHistory();
const loadInitialHistory = () => loadHistory(true);

const isHistoryScrollNearBottom = (element: HTMLElement) =>
  element.scrollTop + element.clientHeight >=
  element.scrollHeight - HISTORY_SCROLL_THRESHOLD;

const onHistoryScroll = (event: Event) => {
  if (!isHistoryScrollLoadingEnabled.value) return;

  const element = event.currentTarget as HTMLElement;
  if (isHistoryScrollNearBottom(element)) void loadMoreHistory();
};

const enableHistoryScrollLoading = async () => {
  isHistoryScrollLoadingEnabled.value = true;
  await loadMoreHistory();
};

const fillHistoryViewport = async () => {
  const element = historyScrollRef.value;
  if (
    element &&
    hasMoreHistory.value &&
    element.scrollHeight <= element.clientHeight
  ) {
    await loadMoreHistory();
  }
};

const pendingDeletes = ref<{ ruleId: number; groupId: number }[]>([]);
const initialState = ref<{
  owner: number | null;
  special: (string | number)[];
  rulesValues: Record<number, Record<string, number>>;
} | null>(null);

const hasChanges = computed(() => {
  if (!initialState.value) return false;

  if (selectedPerson.value !== initialState.value.owner) {
    return true;
  }

  if (pendingDeletes.value.length > 0) {
    console.log("[hasChanges] pendingDeletes:", pendingDeletes.value);
    return true;
  }

  const currentSpecial = selectedPersonSpecial.value as (string | number)[];
  const initialSpecial = initialState.value.special;
  if (currentSpecial.length !== initialSpecial.length) {
    return true;
  }
  const currentSet = new Set(currentSpecial);
  if (initialSpecial.some((id) => !currentSet.has(id))) {
    return true;
  }

  if (
    localContainer.value &&
    Array.isArray(localContainer.value.SpecialRules)
  ) {
    for (const rule of localContainer.value.SpecialRules) {
      if (rule.CanBeDeletedFront) continue;
      const initRule = initialState.value.rulesValues[rule.Group.Id as number];
      if (!initRule) continue;
      for (const re of rule.Rules) {
        if (initRule[re.Name] !== Number(re.Value)) return true;
      }
    }
  }

  return false;
});
const selectedPerson = ref<number | null>(null);
const selectedPersonSpecial = ref([]);

const stylesTrigger: any = {
  minHeight: `18px`,
  padding: 0,
  width: "fit-content",
  border: `none`,
  backgroundColor: `transparent`,
};
let isInitializing = false;

watch(
  () => props.container,
  (val) => {
    if (val) {
      isInitializing = true;
      localContainer.value = reactive({
        GlobalVisible: val.GlobalVisible,
        InheritVisible: val.InheritVisible,
        SpecialVisible: val.SpecialVisible,
        GlobalRules: val.GlobalRules.map((r) => ({
          ...r,
          Rules: r.Rules.map((re) => ({ ...re, Value: Number(re.Value) })),
        })),
        InheritedRules: val.InheritedRules.map((r) => ({
          ...r,
          Rules: r.Rules.map((re) => ({ ...re, Value: Number(re.Value) })),
        })),
        SpecialRules: val.SpecialRules.map((r) => ({
          ...r,
          Rules: r.Rules.map((re) => ({ ...re, Value: Number(re.Value) })),
        })),
      });

      const allRules = [
        ...val.GlobalRules,
        ...val.InheritedRules,
        ...val.SpecialRules,
      ];
      const ownerRule = allRules.find((r) => r.Owner);
      selectedPerson.value = ownerRule ? ownerRule.Group.Id : null;

      selectedPersonSpecial.value = val.SpecialRules.filter(
        (r) => !r.Owner,
      ).map((r) => r.Group.Id);

      const rulesValues: Record<number, Record<number, number>> = {};
      val.SpecialRules.filter((r) => !r.Owner).forEach((r) => {
        rulesValues[r.Group.Id] = {};
        r.Rules.forEach((re) => {
          rulesValues[r.Group.Id][re.Name] = Number(re.Value);
        });
      });

      initialState.value = {
        owner: ownerRule ? ownerRule.Group.Id : null,
        special: val.SpecialRules.filter((r) => !r.Owner).map(
          (r) => r.Group.Id,
        ),
        rulesValues,
      };

      nextTick(() => {
        isInitializing = false;
      });
    } else {
      localContainer.value = null;
      selectedPerson.value = null;
      selectedPersonSpecial.value = [];
      initialState.value = null;
      isInitializing = false;
    }

    addGroupSection.value = null;
  },
  { immediate: true },
);

const setAllRules = (rule: CommonRule, mode: "max" | "min") => {
  rule.Rules.forEach((selector) => {
    if (mode === "max") {
      if (selector.RuleType === 0) selector.Value = 2;
      else if (selector.RuleType === 1) selector.Value = 1;
      else selector.Value = 2;
    } else {
      if (selector.RuleType === 0) selector.Value = 0;
      else if (selector.RuleType === 1) selector.Value = 0;
      else selector.Value = 1;
    }
  });
  rule.CanSave = true;
};

const optionsDenyReadUpdate = computed(() => [
  { id: "2", label: String(i18n.global.t("AccessLevel.full")) },
  { id: "1", label: String(i18n.global.t("AccessLevel.read")) },
  { id: "0", label: String(i18n.global.t("AccessLevel.denied")) },
]);
const optionsAllowedDenied = computed(() => [
  { id: "1", label: String(i18n.global.t("AccessLevel.full")) },
  { id: "0", label: String(i18n.global.t("AccessLevel.denied")) },
]);
const optionsReadUpdate = computed(() => [
  { id: "2", label: String(i18n.global.t("AccessLevel.full")) },
  { id: "1", label: String(i18n.global.t("AccessLevel.read")) },
]);

const ruleLabel = (rule: RuleElement): string => {
  const key = `AccessLevel.${rule.Name}`;
  return i18n.global.te(key) ? String(i18n.global.t(key)) : rule.Text;
};

const optionsFor = (ruleType: number) => {
  if (ruleType === 0) return optionsDenyReadUpdate.value;
  if (ruleType === 1) return optionsAllowedDenied.value;
  return optionsReadUpdate.value;
};

const selectClass = (s: RuleElement) => {
  if (s.RuleType === 0) {
    return {
      "rules-tab__selector-select--red": s.Value === 0,
      "rules-tab__selector-select--yellow": s.Value === 1,
      "rules-tab__selector-select--green": s.Value === 2,
    };
  }
  if (s.RuleType === 1) {
    return {
      "rules-tab__selector-select--red": s.Value === 0,
      "rules-tab__selector-select--green": s.Value === 1,
    };
  }
  return {
    "rules-tab__selector-select--yellow": s.Value === 1,
    "rules-tab__selector-select--green": s.Value === 2,
  };
};

const ruleTypeMap: Record<string, number> = {
  global: 0,
  inherited: 1,
  special: 2,
};

const onSelectChange = (
  rule: CommonRule,
  selector: RuleElement,
  val: string,
) => {
  selector.Value = Number(val);
  rule.CanSave = true;
};

const onCancel = () => {
  if (!initialState.value || !props.container) return;

  pendingDeletes.value = [];

  selectedPerson.value = initialState.value.owner;

  isInitializing = true;
  selectedPersonSpecial.value = [...initialState.value.special];
  nextTick(() => {
    isInitializing = false;
  });

  if (localContainer.value) {
    localContainer.value.SpecialRules = props.container.SpecialRules.map(
      (r) => ({
        ...r,
        Rules: r.Rules.map((re) => ({ ...re })),
      }),
    );
  }

  emit("cancel");
};

const canDeleteRule = (rule: CommonRule, sectionKey: string) => {
  if (sectionKey === "inherited") {
    return !rule.Owner && (rule.CanDelete || rule.CanBeDeletedFront);
  }
  if (sectionKey === "special") {
    return rule.CanDelete || rule.CanBeDeletedFront;
  }
  return false;
};

const onSaveRule = async (rule: CommonRule, sectionKey: string) => {
  try {
    if (props.type == "client")
      await AccessApi.saveRuleInClient(
        props.entityId,
        rule.Rules,
        rule.Group.Id,
        ruleTypeMap[sectionKey],
      );
    else
      await AccessApi.saveRuleInProject(
        props.entityId,
        rule.Rules,
        rule.Group.Id,
        ruleTypeMap[sectionKey],
      );
    emit("refresh");
  } catch (e) {
    console.error(e);
  }
};

const onDeleteRule = async (rule: CommonRule, section: SectionDef) => {
  if (rule.CanBeDeletedFront) {
    const idx = section.rules.findIndex((r) => r.Group.Id === rule.Group.Id);
    if (idx !== -1) section.rules.splice(idx, 1);
    return;
  }

  try {
    console.log(props.type);
    const inherited = section.key === "inherited";
    if (props.type == "client")
      await AccessApi.removeRuleInClient(
        rule.Id,
        props.entityId,
        inherited,
        rule.Group.Id,
      );
    else
      await AccessApi.removeRuleInProject(
        rule.Id,
        props.entityId,
        inherited,
        rule.Group.Id,
      );
    emit("refresh");
  } catch (e) {
    console.error(e);
  }
};

const onDeleteSpecialRule = (rule: CommonRule) => {
  if (rule.CanBeDeletedFront) {
    selectedPersonSpecial.value = selectedPersonSpecial.value.filter(
      (id) => id !== rule.Group.Id,
    );
  } else {
    pendingDeletes.value.push({ ruleId: rule.Id, groupId: rule.Group.Id });
    const specialRules = sections.value[2].rules;
    const idx = specialRules.findIndex((r) => r.Group.Id === rule.Group.Id);
    if (idx !== -1) specialRules.splice(idx, 1);
    selectedPersonSpecial.value = selectedPersonSpecial.value.filter(
      (id) => id !== rule.Group.Id,
    );
  }
};

const onAddGroup = async (section: SectionDef) => {
  if (addGroupSection.value === section.key) {
    addGroupSection.value = null;
    return;
  }

  try {
    isLoadingGroups.value = true;
    const result =
      props.type == "client"
        ? await AccessApi.getGroupsInClient(props.entityId)
        : await AccessApi.getGroupsInProject(props.entityId);
    const existingIds = new Set(section.rules.map((r) => r.Group.Id));
    availableGroups.value = (result.Groups ?? []).filter(
      (g) => !existingIds.has(g.Id),
    );
    availableRulesTemplate.value = result.Rules ?? [];
    addGroupSection.value = section.key;
  } catch (e) {
    console.error(e);
  } finally {
    isLoadingGroups.value = false;
  }
};

const onPickGroup = (group: CommonEntity, section: SectionDef) => {
  const newRule: CommonRule = reactive({
    Id: 0,
    Visible: false,
    CanSave: true,
    CanDelete: false,
    CanBeDeletedFront: true,
    Group: { Id: group.Id, Name: group.Name },
    Rules: availableRulesTemplate.value.map((r) => ({ ...r })),
    Global: false,
    Owner: false,
    Inherited: section.key === "inherited",
    OwnerGroup: null,
    Reduced: false,
    Advanced: false,
    Given: false,
  });
  section.rules.push(newRule);
  addGroupSection.value = null;
};

const sections = computed<SectionDef[]>(() => {
  const c = localContainer.value;
  if (!c) return [];

  return [
    {
      key: "global",
      title: String(i18n.global.t("permissions_global_rules")),
      rules: c.GlobalRules,
      visible: c.GlobalVisible,
      readonly: true,
      toggle: () => (c.GlobalVisible = !c.GlobalVisible),
    },
    {
      key: "inherited",
      title: String(i18n.global.t("permissions_inherited_rules")),
      rules: c.InheritedRules,
      visible: c.InheritVisible,
      readonly: !props.canEdit,
      toggle: () => (c.InheritVisible = !c.InheritVisible),
    },
    {
      key: "special",
      title: String(i18n.global.t("permissions_special_rules")),
      rules: c.SpecialRules,
      visible: c.SpecialVisible,
      readonly: !props.canEdit,
      toggle: () => (c.SpecialVisible = !c.SpecialVisible),
    },
  ];
});

const groupsRules = ref<WorkersAndAccessGroupsInSettingsGiver>();

onMounted(async () => {
  groupsRules.value = await AccessApi.getWorkersAndAccessGroups();

  try {
    const result =
      props.type === "client"
        ? await AccessApi.getGroupsInClient(props.entityId)
        : await AccessApi.getGroupsInProject(props.entityId);

    await loadInitialHistory();

    availableRulesTemplate.value = result.Rules ?? [];
  } catch (e) {
    console.error(e);
  }
});

watch(
  selectedPersonSpecial,
  (newVal: (string | number)[], oldVal: (string | number)[]) => {
    if (isInitializing) return;
    if (!localContainer.value) return;

    const specialRules = sections.value[2].rules;

    const added = newVal.filter((id) => !oldVal.includes(id));
    const removed = oldVal.filter((id) => !newVal.includes(id));

    added.forEach((id) => {
      if (specialRules.some((r) => r.Group.Id === id)) return;

      const label = findLabelById(id);

      const newRule: CommonRule = reactive({
        Id: 0,
        Visible: false,
        CanSave: true,
        CanDelete: false,
        CanBeDeletedFront: true,
        Group: { Id: id as number, Name: label },
        Rules: availableRulesTemplate.value.map((r) => ({ ...r })),
        Global: false,
        Owner: false,
        Inherited: false,
        OwnerGroup: null,
        Reduced: false,
        Advanced: false,
        Given: false,
      });
      specialRules.push(newRule);
    });

    removed.forEach((id) => {
      const idx = specialRules.findIndex((r) => r.Group.Id === id && !r.Owner);
      if (idx === -1) return;

      const rule = specialRules[idx];
      if (
        !rule.CanBeDeletedFront &&
        !pendingDeletes.value.some(
          (item) => item.ruleId === rule.Id && item.groupId === rule.Group.Id,
        )
      ) {
        pendingDeletes.value.push({
          ruleId: rule.Id,
          groupId: rule.Group.Id,
        });
      }
      specialRules.splice(idx, 1);
    });
  },
  { deep: true },
);

const findLabelById = (id: string | number): string => {
  for (const item of optionsPersonsSpecial.value) {
    if (item.id === id) return item.label;
    if ("children" in item && item.children) {
      const child = item.children.find((c) => c.id === id);
      if (child) return child.label;
    }
  }
  return String(id);
};
const save = async () => {
  if (!localContainer.value) return;
  const specialSection = sections.value[2];
  const toSave = specialSection.rules.filter((r) => r.CanSave);

  try {
    if (
      selectedPerson.value !== null &&
      selectedPerson.value !== initialState.value?.owner
    ) {
      await AccessApi.editGroupOwnage(
        selectedPerson.value,
        props.type === "client",
        [props.entityId],
      );
    }

    for (const { ruleId, groupId } of pendingDeletes.value) {
      await (props.type === "client"
        ? AccessApi.removeRuleInClient(ruleId, props.entityId, false, groupId)
        : AccessApi.removeRuleInProject(
            ruleId,
            props.entityId,
            false,
            groupId,
          ));
    }

    for (const rule of toSave) {
      await (props.type === "client"
        ? AccessApi.saveRuleInClient(
            props.entityId,
            rule.Rules,
            rule.Group.Id,
            2,
          )
        : AccessApi.saveRuleInProject(
            props.entityId,
            rule.Rules,
            rule.Group.Id,
            2,
          ));
    }

    pendingDeletes.value = [];
    emit("save");
    emit("refresh");
  } catch (e) {
    console.error(e);
  }
};

const openDropdown = () => {
  emit("openDropdown");
};

const closeDropdown = () => {
  emit("closeDropdown");
};

const updateSelected = (newSelected: (string | number)[]) => {
  selectedPerson.value =
    newSelected.length > 0
      ? (newSelected[newSelected.length - 1] as number)
      : null;
};

const updateSelectedSpecial = (newSelected) => {
  selectedPersonSpecial.value = newSelected;
};

const initialOwnerOption = computed<SelectOption[]>(() => {
  if (!props.container) return [];

  const ownerRule = [
    ...props.container.GlobalRules,
    ...props.container.InheritedRules,
    ...props.container.SpecialRules,
  ].find((rule) => rule.Owner);

  return ownerRule
    ? [
        {
          id: ownerRule.Group.Id,
          label: ownerRule.Group.Name,
          type: "item" as const,
        },
      ]
    : [];
});

const optionsPersons = computed<SelectOption[]>(() => {
  if (!groupsRules.value?.Holders.length) return initialOwnerOption.value;

  const groups: SelectOption[] = [];
  const workersWithoutDepartment: {
    id: number;
    label: string;
    type: "item";
  }[] = [];

  groupsRules.value?.Holders.forEach((el, index) => {
    if (el.Departament) {
      groups.push({
        id: index + 999999,
        label: el.Departament.Name,
        type: "group" as const,
        selectable: true,
        children:
          el.Departament.Workers?.map((worker) => ({
            id: worker.GroupId,
            label: worker.Name,
            type: "item" as const,
          })) ?? [],
      });
    } else if (el.IsWorker && el.Worker) {
      workersWithoutDepartment.push({
        id: el.Worker.GroupId,
        label: el.Worker.Name,
        type: "item" as const,
      });
    }
  });

  groupsRules.value?.Groups.forEach((el, index) => {
    if (!el.IsPersonal) {
      groups.push({
        id: el.Id,
        label: el.Name,
        type: "group" as const,
        selectable: true,
        children: [],
      });
    }
  });

  if (workersWithoutDepartment.length > 0) {
    groups.push({
      id: -1,
      label: String(i18n.global.t("permissions_no_department")),
      type: "group" as const,
      selectable: false,
      children: workersWithoutDepartment,
    });
  }

  const ownerId = initialOwnerOption.value[0]?.id;
  const hasOwner = groups.some(
    (item) =>
      item.id === ownerId ||
      ("children" in item &&
        item.children.some((child) => child.id === ownerId)),
  );

  if (ownerId !== undefined && !hasOwner) {
    groups.unshift(...initialOwnerOption.value);
  }

  return groups;
});

const optionsPersonsSpecial = computed<SelectOption[]>(() => {
  if (!groupsRules.value?.Holders.length) return [];

  const groups: SelectOption[] = [];
  const workersWithoutDepartment: {
    id: number;
    label: string;
    type: "item";
  }[] = [];

  groupsRules.value?.Holders.forEach((el, index) => {
    if (el.Departament) {
      groups.push({
        id: index + 999999,
        label: el.Departament.Name,
        type: "group" as const,
        selectable: true,
        children:
          el.Departament.Workers?.map((worker) => ({
            id: worker.GroupId,
            label: worker.Name,
            type: "item" as const,
          })) ?? [],
      });
    } else if (el.IsWorker && el.Worker) {
      workersWithoutDepartment.push({
        id: el.Worker.GroupId,
        label: el.Worker.Name,
        type: "item" as const,
      });
    }
  });

  groupsRules.value?.Groups.forEach((el, index) => {
    if (!el.IsPersonal) {
      groups.push({
        id: el.Id,
        label: el.Name,
        type: "group" as const,
        selectable: true,
        children: [],
      });
    }
  });

  if (workersWithoutDepartment.length > 0) {
    groups.push({
      id: -1,
      label: String(i18n.global.t("permissions_no_department")),
      type: "group" as const,
      selectable: false,
      children: workersWithoutDepartment,
    });
  }

  return groups;
});

const getDate = (date: string) => {
  return moment(date).format("HH:mm DD.MM.YYYY");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.container)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            ref_key: "historyScrollRef",
            ref: historyScrollRef,
            class: "rules-tab__scroll",
            onScrollPassive: onHistoryScroll
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("owner")), 1),
              _createVNode(AppSelect, {
                modelValue: selectedPerson.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPerson).value = $event)),
                class: "rules-tab__choice-line-select",
                "dropdown-class": "select-dropdown--choice-rules-modal",
                "custom-search-style": { width: '430px' },
                placeholder: _ctx.$t('permissions_select_users'),
                items: optionsPersons.value,
                "min-dropdown-width": 665,
                "dropdown-height": 600,
                searchable: "",
                "show-search-button": false,
                "owner-choise": "",
                "show-dropdown-close": "",
                onOpen: openDropdown,
                onClose: closeDropdown
              }, {
                dropdown: _withCtx(({ items, selected, select, getGroupState, search }) => [
                  _createVNode(UserGroupDropdownContent, {
                    items: items,
                    selected: selected,
                    select: select,
                    "get-group-state": getGroupState,
                    updateSelected: updateSelected,
                    search: search,
                    "single-mode": true,
                    "current-owner": selectedPerson.value
                  }, null, 8, ["items", "selected", "select", "get-group-state", "search", "current-owner"])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "items"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("special_rules")), 1),
              _createVNode(AppSelect, {
                modelValue: selectedPersonSpecial.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPersonSpecial).value = $event)),
                "dropdown-class": "select-dropdown--choice-rules-modal",
                class: "rules-tab__choice-line-select",
                "custom-search-style": { width: '430px' },
                style: {"width":"170px"},
                placeholder: _ctx.$t('add_part'),
                items: optionsPersonsSpecial.value,
                "min-dropdown-width": 697,
                "dropdown-height": 559,
                "dropdown-label": _ctx.$t('add_part'),
                searchable: "",
                "show-search-button": false,
                multiple: "",
                "show-dropdown-close": "",
                "show-divider": "",
                onOpen: openDropdown,
                onClose: closeDropdown,
                closeOnSelect: false
              }, {
                dropdown: _withCtx(({ items, selected, select, getGroupState, search }) => [
                  _createVNode(UserGroupDropdownContent, {
                    items: items,
                    selected: selected,
                    select: select,
                    "get-group-state": getGroupState,
                    updateSelected: updateSelectedSpecial,
                    search: search
                  }, null, 8, ["items", "selected", "select", "get-group-state", "search"])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "items", "dropdown-label"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (sections.value[2].rules?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sections.value[2].rules, (rule, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${sections.value[2].key}-${rule.Group.Id}-${i}`,
                      class: _normalizeClass(["rules-tab__rule", [{ 'rules-tab__rule-visible': rule.Visible }]])
                    }, [
                      _createElementVNode("div", {
                        class: "rules-tab__rule-header",
                        onClick: ($event: any) => (rule.Visible = !rule.Visible)
                      }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(rule.Group.Name), 1),
                        _createVNode(AppTooltip, {
                          text: rule.Visible ? _ctx.$t('permissions_collapse_list') : _ctx.$t('permissions_expand_list')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              name: 'chevron-down',
                              class: _normalizeClass([{ 'rules-tab__rule-chevron--open': rule.Visible }, "rules-tab__rule-chevron"]),
                              width: "14px",
                              color: "#979797",
                              "hover-color": "#377444",
                              onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                            }, null, 8, ["class"])
                          ]),
                          _: 2
                        }, 1032, ["text"]),
                        _createVNode(AppTooltip, {
                          text: _ctx.$t('permissions_delete_special')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              name: 'close-bold',
                              class: _normalizeClass([{ 'rules-tab__rule-chevron': rule.Visible == true }, "rules-tab__rule-icon"]),
                              width: "12px",
                              color: "#D2D2D2",
                              "hover-color": "#D05A4F",
                              onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                              onClick: _withModifiers(($event: any) => (onDeleteSpecialRule(rule)), ["stop"])
                            }, null, 8, ["class", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["text"])
                      ], 8, _hoisted_7),
                      (rule.Visible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("button", {
                                class: "rules-tab__rule-body-bulk-btn rules-tab__bulk-btn--allow",
                                onClick: _withModifiers(($event: any) => (setAllRules(rule, 'max')), ["stop"])
                              }, _toDisplayString(_ctx.$t("permissions_allow_all")), 9, _hoisted_11),
                              _createElementVNode("button", {
                                class: "rules-tab__rule-body-bulk-btn rules-tab__bulk-btn--deny",
                                onClick: _withModifiers(($event: any) => (setAllRules(rule, 'min')), ["stop"])
                              }, _toDisplayString(_ctx.$t("permissions_deny_all")), 9, _hoisted_12)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rule.Rules, (selector) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: selector.Id,
                                class: "rules-tab__selector"
                              }, [
                                _createElementVNode("label", _hoisted_13, _toDisplayString(ruleLabel(selector)), 1),
                                _createVNode(RulesSelectorDropdown, {
                                  class: _normalizeClass(["rules-tab__selector-select", selectClass(selector)]),
                                  "model-value": String(selector.Value),
                                  items: optionsFor(selector.RuleType),
                                  "custom-trigger-style": stylesTrigger,
                                  "onUpdate:modelValue": (val) => onSelectChange(rule, selector, String(val))
                                }, null, 8, ["class", "model-value", "items", "onUpdate:modelValue"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            (historyGroups.value?.Records.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("permissions_changed")) + ":", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyGroups.value.Records, (change, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "rules-tab__field-value-col",
                      key: change.Id
                    }, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(getDate(change.CreateTime)) + " ", 1),
                      _createElementVNode("span", _hoisted_17, "[" + _toDisplayString(change.ChangerName) + "]", 1),
                      _createElementVNode("span", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formatChangelogText)(change.Text), (segment, segmentIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: segmentIndex }, [
                            (segment.italic)
                              ? (_openBlock(), _createElementBlock("em", _hoisted_19, _toDisplayString(segment.text), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(segment.text), 1))
                          ], 64))
                        }), 128))
                      ]),
                      (
              !isHistoryScrollLoadingEnabled.value &&
              hasMoreHistory.value &&
              index === historyGroups.value.Records.length - 1
            )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "rules-tab__field-value-col-show-more",
                            onClick: enableHistoryScrollLoading
                          }, _toDisplayString(_ctx.$t("permissions_more")) + " " + _toDisplayString(historyGroups.value.TotalCount - historyGroups.value.Records.length), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 544)
        ]))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "rules-tab__line" }, null, -1)),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(AppButton, {
        type: "secondary",
        label: _ctx.$t('cancel_short'),
        onClick: onCancel
      }, null, 8, ["label"]),
      _createVNode(AppButton, {
        type: "primary",
        label: _ctx.$t('save'),
        onClick: save,
        disabled: !hasChanges.value || selectedPerson.value === null
      }, null, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})